import { Chip, InputLabel, MenuItem } from '@mui/material';
import React from 'react';
import { AdvancedFilter } from '../../interfaces/interfaces';
import VySelect from './VySelect';
interface VyFilterSelectProps {
  filters: AdvancedFilter[];
  excludedValues?: string[];
  label?: string;
  onChange?: (values: string[]) => void;
  selectedValues: string[];
  multiple?: boolean;
}

export const VyFilterSelect = (props: VyFilterSelectProps) => {
  const { filters, excludedValues = [], label, selectedValues = [], multiple = true, onChange } = props;

  function handleSelect(event: any) {
    console.log(event.target);
    if (!event?.target?.value) return;
    if (onChange) onChange(event.target.value);
  }

  const labelForFilterValue = (id: string) => {
    console.log(id);
    try {
      return filters
        .map((f: any) => f.categoryFilterValues)
        .flat()
        .find((e: any) => e._id === id).value;
    } catch (err) {
      console.error(err);
      return 'Malformed Value';
    }
  };

  if (!filters || filters.length === 0) return <></>;

  return (
    <div className="w-full max-w-full">
      {label && <InputLabel>{label}</InputLabel>}
      <VySelect
        style={{ width: '100%' }}
        value={selectedValues}
        onChange={handleSelect}
        variant="outlined"
        multiple={multiple}
        renderValue={(selected) => (
          <div className="w-full min-w-full flex flex-wrap">
            {(selected as string[]).map((value) => (
              <Chip key={value} label={labelForFilterValue(value)} />
            ))}
          </div>
        )}>
        {filters.map((f) => {
          return f.categoryFilterValues
            .filter((v) => !excludedValues.includes(v._id))
            .map((v) => (
              <MenuItem key={v._id} value={v._id}>
                {v.value}
              </MenuItem>
            ));
        })}
      </VySelect>
    </div>
  );
};
